$(function () {

	//アコーディオン
	$(".toggle_btn").on("click", function() {
		if($(this).hasClass('open')){
			$(this).next().removeClass("open");
			$(this).removeClass("open");
		} else if (!$(this).hasClass("open")) {
			$(".toggle_btn").removeClass("open");
			$(".toggle_content").removeClass("open");
			$(this).next().addClass("open");
			$(this).addClass("open");
		}
		var position = $(this).offset().top;
		$("html,body").animate({
			scrollTop : position - 80 //スクロール位置調整
		}, {
			queue : false
		});
	});

	//閉じるボタンがクリックされたら
	$('.btn_close').click(function () {
		$('.toggle_btn').removeClass("open");
		$('.toggle_content').removeClass("open");
	});

	// カタ自動補完
	$.fn.autoKana('#name', '#kana', {
		katakana : true  //true：カタカナ、false：ひらがな（デフォルト）
	});

});